import {
  FieldPath,
  FieldValues,
  UseFormReturn,
  useWatch,
} from "react-hook-form";
import {
  MaybernTableRowWithId,
  useMaybernTableRowController,
} from "shared/components/table/maybern/MaybernTableRowController";
import { UseArraySetter } from "shared/hooks/useArrayState";
import { useFormStateDispatch } from "shared/utils/FormUtils";

export const useMaybernTableFormRowController = <
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  TFieldRow extends MaybernTableRowWithId<
    TFieldValues[TFieldName][number]
  > = MaybernTableRowWithId<TFieldValues[TFieldName][number]>,
>(
  form: UseFormReturn<TFieldValues>,
  name: TFieldName,
) => {
  const rows = useWatch({
    control: form.control,
    name,
  });
  const setRows = useFormStateDispatch(form, name) as UseArraySetter<TFieldRow>;
  return useMaybernTableRowController<TFieldRow>(rows, setRows);
};
